import React from 'react'
import type { Control } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import type { TextFieldWithFormattingProps } from './TextFieldWithFormatting'
import TextFieldWithFormatting from './TextFieldWithFormatting'

type ControlledTextFieldWithFormattingProps = {
  control: Control
  name: string
  multiline?: boolean
  defaultValue?: string
  rules?: { [key: string]: string }
} & TextFieldWithFormattingProps

function ControlledTextFieldWithFormatting({
  control,
  name,
  defaultValue,
  rules,
  ...rest
}: ControlledTextFieldWithFormattingProps) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ value, onChange }) => <TextFieldWithFormatting value={value} onChange={onChange} {...rest} />}
    />
  )
}

export default ControlledTextFieldWithFormatting
